<template>
    <BaseButton
        :class="['text-theme-icon transition', { 'invisible opacity-0': !showBackButton }]"
        :tooltip="localizations[lang].tooltips.back"
        dusk="closeReader"
        icon="arrow-left"
        :disabled="!showBackButton"
        @click="goBack()"
    />
</template>

<script>
import BaseButton from './BaseButton.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    components: {
        BaseButton,
    },
    computed: {
        ...mapState(['localizations', 'lang', 'ui']),
        ...mapGetters(['isEmbeddedMode', 'isOpenSomeFeatureOrSettings']),
        showBackButton() {
            if (!this.isEmbeddedMode) {
                return true;
            }

            return this.isOpenSomeFeatureOrSettings || this.ui.listening.opened;
        },
    },
    methods: {
        ...mapActions(['goBack']),
    },
};
</script>
